import { ITEMS as LOCAL_STORAGE_ITEMS } from 'consts/localStorage';

export const SESSION_STORAGE_ITEMS = {
  seedForKarmaEarnOfferList: 'seedForKarmaEarnOfferList',
  seedForKarmaEarnGameList: 'seedForKarmaEarnGameList',
  userCountryCode: 'country_code',
  extensionInstalled: 'extensionInstalled',
  sweOnboardingUserId: LOCAL_STORAGE_ITEMS.sweOnboardingUserId,
  sweOnboardingRedirect: LOCAL_STORAGE_ITEMS.sweOnboardingRedirect,
  sweOnboardingActivationEventSent: LOCAL_STORAGE_ITEMS.sweOnboardingEventSent,
};
